// import saga helper
import { takeEvery, put, call, all } from "redux-saga/effects";
import {
  BANK_LIST_REQUEST,
  BANK_TRANSACTION_LIST_REQUEST,
  BANK_ALL_TRANSACTION_LIST_REQUEST,
  BANK_UNALLOCATED_TRANSACTION_LIST_REQUEST,
  ITEM_ALLOCATION_LIST_REQUEST,
  CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_REQUEST,
  UNCLEAR_TRANSACTION_REQUEST,
  CUSTOMER_SEARCH_ALL_TRANSACTIONS_REQUEST,
  SUPPLIER_SEARCH_ALL_TRANSACTIONS_REQUEST,
  CREATE_SINGLE_BANK_TRANSACTION_REQUEST,
  BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_REQUEST,
  BANK_UPLOAD_TRANSACTIONS_REQUEST,
  BANK_ASSIGNED_ONLY_TRANSACTION_LIST_REQUEST,
  BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_REQUEST,
  BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_REQUEST,
  CREATE_BANK,
  UPDATE_BANK,
  DELETE_BANK,
  SYNC_BANK_TRANSACTIONS,
  SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_REQUEST,
  SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_REQUEST,
  GET_BANK_ACCOUNT_STATUS_LIST,
  BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_REQUEST,
  GET_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST,
  UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST,
  BANK_ACCOUNT_PROVIDER_LIST_REQUEST,
  GET_BANK_ACCOUNT_STATUS_DATA_REQUEST,
  CREATE_BANK_ACCOUNT_STATUS_REQUEST,
  UPDATE_BANK_ACCOUNT_STATUS_REQUEST,
  DELETE_BANK_ACCOUNT_STATUS_REQUEST,
  BANK_ACCOUNT_FEED_CONNECTION_REQUEST,
  BANK_ACCOUNT_FEED_MAP_ACCOUNTS_REQUEST,
  BANK_TRANSACTION_IMPORT_REQUEST,
  BANK_TRANSACTION_ALLOCATION_UNCLEAR_REQUEST,
  BANK_TRANSACTION_ALLOCATION_SPLIT_REQUEST,
  BANK_ACCOUNT_FEED_RECONNECTION_REQUEST,
  CLEARING_DOCUMENT_SEARCH_REQUEST,
  BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_REQUEST,
  BANK_ACCOUNT_ATTACHMENT_SEARCH,
  BANK_ACCOUNT_ATTACHMENT_DELETE,
  BANK_ACCOUNT_STATEMENT_SEARCH,
  BANK_ACCOUNT_STATEMENT_DELETE,
} from "./actionType";

// Action Bank List

import {
  getBankListSuccess,
  getBankListError,
  getBankTransactionListSuccess,
  getBankTransactionListError,
  getAllBankTransactionListSuccess,
  getAllBankTransactionListError,
  getUnAllocatedBankTransactionListSuccess,
  getUnAllocatedBankTransactionListError,
  getItemAllocationListSuccess,
  getItemAllocationListError,
  clearAllocatedTransactionAndItemsSuccess,
  clearAllocatedTransactionAndItemsError,
  unclearTransactionSuccess,
  unclearTransactionError,
  customerSearchAllTransactionsSuccess,
  customerSearchAllTransactionsError,
  supplierSearchAllTransactionsSuccess,
  supplierSearchAllTransactionsError,
  createSingleBankTransactionSuccess,
  createSingleBankTransactionError,
  bankSingleCustomerTransactionPDFStatementSuccess,
  bankSingleCustomerTransactionPDFStatementError,
  bankUploadTransactionsFileSuccess,
  bankUploadTransactionsFileError,
  getAssignedOnlyBankTransactionListSuccess,
  getAssignedOnlyBankTransactionListError,
  bankAssignTransactionToCustomerSuccess,
  bankAssignTransactionToCustomerError,
  bankUnassignTransactionFromCustomerSuccess,
  bankUnassignTransactionFromCustomerError,
  createBankSuccess,
  createBankError,
  updateBankSuccess,
  updateBankError,
  deleteBankSuccess,
  deleteBankError,
  syncBankTransactionsSuccess,
  syncBankTransactionsError,
  singleCustomerTransactionOpenItemsPDFStatementSuccess,
  singleCustomerTransactionOpenItemsPDFStatementError,
  singleCustomerTransactionAllItemsPDFStatementSuccess,
  singleCustomerTransactionAllItemsPDFStatementError,
  getBankAccountStatusListSuccess,
  getBankAccountStatusListError,
  bankTransactionAllocationDeleteTransactionSuccess,
  bankTransactionAllocationDeleteTransactionError,
  getManualBankTransactionDetailsSuccess,
  getManualBankTransactionDetailsError,
  updateManualBankTransactionDetailsSuccess,
  updateManualBankTransactionDetailsError,
  bankAccountProviderListSuccess,
  bankAccountProviderListError,
  getBankAccountStatusDataSuccess,
  getBankAccountStatusDataError,
  createBankAccountStatusSuccess,
  createBankAccountStatusError,
  updateBankAccountStatusSuccess,
  updateBankAccountStatusError,
  deleteBankAccountStatusSuccess,
  deleteBankAccountStatusError,
  bankAccountFeedConnectionSuccess,
  bankAccountFeedConnectionError,
  bankAccountFeedMapAccountsSuccess,
  bankAccountFeedMapAccountsError,
  bankTransactionImportSuccess,
  bankTransactionImportError,
  bankTransactionAllocationUnclearSuccess,
  bankTransactionAllocationUnclearError,
  bankTransactionAllocationSplitSuccess,
  bankTransactionAllocationSplitError,
  bankAccountFeedReconnectionSuccess,
  bankAccountFeedReconnectionError,
  clearingDocumentSearchSuccess,
  clearingDocumentSearchError,
  bankTransactionAllocationAutoClearSuccess,
  bankTransactionAllocationAutoClearError,
  searchBankAccountAttachmentSuccess,
  searchBankAccountAttachmentFailure,
  deleteBankAccountAttachmentSuccess,
  deleteBankAccountAttachmentFailure,
  searchBankAccountStatementSuccess,
  searchBankAccountStatementFailure,
  deleteBankAccountStatementSuccess,
  deleteBankAccountStatementFailure,
} from "./action";

import {
  getBankListApiCall,
  getSingleBankTransactionApiCall,
  getAllBanksTransactionListApiCall,
  getBankUnAllocatedTransactionListApiCall,
  getBankUnAllocatedItemListApiCall,
  getBankClearTransactionAndItemRecquestApiCall,
  getBankUnClearTransactionAndItemRecquestApiCall,
  getCustomerSearchAllTransactionsApiCall,
  getSupplierSearchAllTransactionsApiCall,
  getCreateSingleBankTransactionApiCall,
  getBankSingleCustomerTransactionStatmentPdfApiCall,
  getBankUploadTransactionsFileApiCall,
  getAssignedOnlyBankTransactionListApiCall,
  getBankAssignTransactionToCustomerApiCall,
  getBankUnassignTransactionFromCustomerApiCall,
  getCreateBankApiCall,
  getUpdateBankApiCall,
  getDeleteBankApiCall,
  getSingleCustomerTransactionOpenItemsPdfApiCall,
  getSingleCustomerTransactionAllItemsPdfApiCall,
  getBankAccountStatusListApiCall,
  getBankTransactionAllocationDeleteTransactionApiCall,
  getManualBankTransactionDetailsApiCall,
  getUpdateManualBankTransactionDetailsApiCall,
  getBankAccountProviderListApiCall,
  getBankAccountStatusDataApiCall,
  createBankAccountStatusApiCall,
  updateBankAccountStatusApiCall,
  deleteBankAccountStatusApiCall,
  syncBankTransactionsApiCall,
  getBankAccountFeedConnectionApiCall,
  getBankAccountFeedMapAccountsApiCall,
  getBankTransactionImportApiCall,
  getBankTransactionAllocationUnclearApiCall,
  getBankTransactionAllocationSplitApiCall,
  getBankAccountFeedReconnectionApiCall,
  searchClearingDocumentApiCall,
  getBankTransactionAllocationAutoClearApiCall,
  searchBankAccountAttachmentApiCall,
  deleteBankAccountAttachmentApiCall,
  searchBankAccountStatementApiCall,
  deleteBankAccountStatementApiCall,
} from "../../helpers/fakebackend_helper";

// get bank list api cal
export function* getBankListApiCallSaga() {
  try {
    const response = yield call(getBankListApiCall);
    yield put(getBankListSuccess(response));
  } catch (error) {
    yield put(getBankListError(error));
  }
}

// get bank list watcher
export function* getBankListWatcher() {
  yield takeEvery(BANK_LIST_REQUEST, getBankListApiCallSaga);
}

// Single Bank Transaction List

// get single bank transaction list api call
export function* getSingleBankTransactionApiCallSaga(action) {
  try {
    const response = yield call(
      getSingleBankTransactionApiCall,
      action.payload
    );
    yield put(getBankTransactionListSuccess(response));
  } catch (error) {
    yield put(getBankTransactionListError(error));
  }
}

// get single bank transaction list watcher

export function* getSingleBankTransactionWatcher() {
  yield takeEvery(
    BANK_TRANSACTION_LIST_REQUEST,
    getSingleBankTransactionApiCallSaga
  );
}

// All Banks Transaction List Saga

// get all banks transaction list api call
export function* getAllBanksTransactionListApiCallSaga() {
  try {
    const response = yield call(getAllBanksTransactionListApiCall);
    yield put(getAllBankTransactionListSuccess(response));
  } catch (error) {
    yield put(getAllBankTransactionListError(error));
  }
}

// get all banks transaction list watcher
export function* getAllBanksTransactionListWatcher() {
  yield takeEvery(
    BANK_ALL_TRANSACTION_LIST_REQUEST,
    getAllBanksTransactionListApiCallSaga
  );
}

// Bank UnAllocated Transaction List Saga

export function* getBankUnAllocatedTransactionListApiCallSaga() {
  try {
    const response = yield call(getBankUnAllocatedTransactionListApiCall);
    yield put(getUnAllocatedBankTransactionListSuccess(response));
  } catch (error) {
    yield put(getUnAllocatedBankTransactionListError(error));
  }
}

export function* getBankUnAllocatedTransactionListWatcher() {
  yield takeEvery(
    BANK_UNALLOCATED_TRANSACTION_LIST_REQUEST,
    getBankUnAllocatedTransactionListApiCallSaga
  );
}

// Bank UnAllocated Item List Saga

export function* getBankUnAllocatedItemListApiCallSaga(action) {
  try {
    const response = yield call(
      getBankUnAllocatedItemListApiCall,
      action.payload
    );
    yield put(getItemAllocationListSuccess(response));
  } catch (error) {
    yield put(getItemAllocationListError(error));
  }
}

export function* getBankUnAllocatedItemListWatcher() {
  yield takeEvery(
    ITEM_ALLOCATION_LIST_REQUEST,
    getBankUnAllocatedItemListApiCallSaga
  );
}

// Bank Clear Transaction And Item Saga

export function* getBankClearTransactionAndItemRecquestApiCallSaga(action) {
  try {
    const response = yield call(
      getBankClearTransactionAndItemRecquestApiCall,
      action.payload
    );
    yield put(clearAllocatedTransactionAndItemsSuccess(response));
  } catch (error) {
    yield put(clearAllocatedTransactionAndItemsError(error));
  }
}

export function* getBankClearTransactionAndItemRecquestWatcher() {
  yield takeEvery(
    CLEAR_ALLOCATED_TRANSACTION_AND_ITEMS_REQUEST,
    getBankClearTransactionAndItemRecquestApiCallSaga
  );
}

// Bank UnClear Transaction And Item Saga

export function* getBankUnClearTransactionAndItemRecquestApiCallSaga(action) {
  try {
    const response = yield call(
      getBankUnClearTransactionAndItemRecquestApiCall,
      action.payload
    );
    yield put(unclearTransactionSuccess(response));
  } catch (error) {
    yield put(unclearTransactionError(error));
  }
}

export function* getBankUnClearTransactionAndItemRecquestWatcher() {
  yield takeEvery(
    UNCLEAR_TRANSACTION_REQUEST,
    getBankUnClearTransactionAndItemRecquestApiCallSaga
  );
}

// Single Customer Search All Transactions Saga

export function* getCustomerSearchAllTransactionsApiCallSaga(action) {
  try {
    const response = yield call(
      getCustomerSearchAllTransactionsApiCall,
      action.payload
    );
    yield put(customerSearchAllTransactionsSuccess(response));
  } catch (error) {
    yield put(customerSearchAllTransactionsError(error));
  }
}

export function* getCustomerSearchAllTransactionsWatcher() {
  yield takeEvery(
    CUSTOMER_SEARCH_ALL_TRANSACTIONS_REQUEST,
    getCustomerSearchAllTransactionsApiCallSaga
  );
}

// Single Supplier Search All Transactions Saga

export function* getSupplierSearchAllTransactionsApiCallSaga(action) {
  try {
    const response = yield call(
      getSupplierSearchAllTransactionsApiCall,
      action.payload
    );
    yield put(supplierSearchAllTransactionsSuccess(response));
  } catch (error) {
    yield put(supplierSearchAllTransactionsError(error));
  }
}

export function* getSupplierSearchAllTransactionsWatcher() {
  yield takeEvery(
    SUPPLIER_SEARCH_ALL_TRANSACTIONS_REQUEST,
    getSupplierSearchAllTransactionsApiCallSaga
  );
}

// Create Single Bank Transaction Saga

export function* getCreateSingleBankTransactionApiCallSaga(action) {
  try {
    const response = yield call(
      getCreateSingleBankTransactionApiCall,
      action.payload
    );
    yield put(createSingleBankTransactionSuccess(response));
  } catch (error) {
    yield put(createSingleBankTransactionError(error));
  }
}

export function* getCreateSingleBankTransactionWatcher() {
  yield takeEvery(
    CREATE_SINGLE_BANK_TRANSACTION_REQUEST,
    getCreateSingleBankTransactionApiCallSaga
  );
}

// Bank Single Customer Transaction Statment PDF

export function* getBankSingleCustomerTransactionStatmentPdfApiCallSaga(
  action
) {
  try {
    const response = yield call(
      getBankSingleCustomerTransactionStatmentPdfApiCall,
      action.payload
    );
    yield put(bankSingleCustomerTransactionPDFStatementSuccess(response));
  } catch (error) {
    yield put(bankSingleCustomerTransactionPDFStatementError(error));
  }
}

export function* getBankSingleCustomerTransactionStatmentPdfWatcher() {
  yield takeEvery(
    BANK_SINGLE_CUSTOMER_TRANSACTION_PDF_STATEMENT_REQUEST,
    getBankSingleCustomerTransactionStatmentPdfApiCallSaga
  );
}

// Bank Upload Transactions file Saga

export function* getBankUploadTransactionsFileApiCallSaga(action) {
  try {
    const response = yield call(
      getBankUploadTransactionsFileApiCall,
      action.payload
    );
    yield put(bankUploadTransactionsFileSuccess(response));
  } catch (error) {
    yield put(bankUploadTransactionsFileError(error));
  }
}

export function* getBankUploadTransactionsFileWatcher() {
  yield takeEvery(
    BANK_UPLOAD_TRANSACTIONS_REQUEST,
    getBankUploadTransactionsFileApiCallSaga
  );
}

// Assigned Only bank Transactions list Saga

export function* getAssignedOnlyBankTransactionListApiCallSaga(action) {
  try {
    const response = yield call(
      getAssignedOnlyBankTransactionListApiCall,
      action.payload
    );
    yield put(getAssignedOnlyBankTransactionListSuccess(response));
  } catch (error) {
    yield put(getAssignedOnlyBankTransactionListError(error));
  }
}

export function* getAssignedOnlyBankTransactionListWatcher() {
  yield takeEvery(
    BANK_ASSIGNED_ONLY_TRANSACTION_LIST_REQUEST,
    getAssignedOnlyBankTransactionListApiCallSaga
  );
}
// Bank Assign Transaction to Customer Saga

export function* getBankAssignTransactionToCustomerApiCallSaga(action) {
  try {
    const response = yield call(
      getBankAssignTransactionToCustomerApiCall,
      action.payload
    );
    yield put(bankAssignTransactionToCustomerSuccess(response));
  } catch (error) {
    yield put(bankAssignTransactionToCustomerError(error));
  }
}

export function* getBankAssignTransactionToCustomerWatcher() {
  yield takeEvery(
    BANK_ASSIGN_TRANSACTION_TO_CUSTOMER_REQUEST,
    getBankAssignTransactionToCustomerApiCallSaga
  );
}
// Bank Unnassign transaction from customer Saga

export function* getBankUnassignTransactionFromCustomerApiCallSaga(action) {
  try {
    const response = yield call(
      getBankUnassignTransactionFromCustomerApiCall,
      action.payload
    );
    yield put(bankUnassignTransactionFromCustomerSuccess(response));
  } catch (error) {
    yield put(bankUnassignTransactionFromCustomerError(error));
  }
}

export function* getBankUnassignTransactionFromCustomerWatcher() {
  yield takeEvery(
    BANK_UNASSIGN_TRANSACTION_FROM_CUSTOMER_REQUEST,
    getBankUnassignTransactionFromCustomerApiCallSaga
  );
}

// Create bank
export function* getCreateBankApiCallSaga(action) {
  try {
    const response = yield call(getCreateBankApiCall, action.payload);
    yield put(createBankSuccess(response));
  } catch (error) {
    yield put(createBankError(error));
  }
}

export function* getCreateBankWatcher() {
  yield takeEvery(CREATE_BANK, getCreateBankApiCallSaga);
}
// Update Bank
export function* getUpdateBankApiCallSaga(action) {
  try {
    const response = yield call(getUpdateBankApiCall, action.payload);
    yield put(updateBankSuccess(response));
  } catch (error) {
    yield put(updateBankError(error));
  }
}

export function* getUpdateBankWatcher() {
  yield takeEvery(UPDATE_BANK, getUpdateBankApiCallSaga);
}

// DELETE BANK
export function* getDeleteBankApiCallSaga(action) {
  try {
    const response = yield call(getDeleteBankApiCall, action.payload);
    yield put(deleteBankSuccess(response));
  } catch (error) {
    yield put(deleteBankError(error));
  }
}

export function* getDeleteBankWatcher() {
  yield takeEvery(DELETE_BANK, getDeleteBankApiCallSaga);
}

// SYNC BANK TRANSACTIONS
export function* syncBankTransactionsSaga(action) {
  try {
    const response = yield call(syncBankTransactionsApiCall, action.payload);
    yield put(syncBankTransactionsSuccess(response));
  } catch (error) {
    yield put(syncBankTransactionsError(error));
  }
}

export function* syncBankTransactionsWatcher() {
  yield takeEvery(SYNC_BANK_TRANSACTIONS, syncBankTransactionsSaga);
}

// Single Customer Transaction Open Items PDF Statement

export function* getBankSingleCustomerTransactionOpenItemsPdfApiCallSaga(
  action
) {
  try {
    const response = yield call(
      getSingleCustomerTransactionOpenItemsPdfApiCall,
      action.payload
    );
    yield put(singleCustomerTransactionOpenItemsPDFStatementSuccess(response));
  } catch (error) {
    yield put(singleCustomerTransactionOpenItemsPDFStatementError(error));
  }
}

export function* getBankSingleCustomerTransactionOpenItemsPdfWatcher() {
  yield takeEvery(
    SINGLE_CUSTOMER_TRANSACTION_OPEN_ITEMS_PDF_STATEMENT_REQUEST,
    getBankSingleCustomerTransactionOpenItemsPdfApiCallSaga
  );
}

//  Single Customer Transaction All Items PDF Statement

export function* getBankSingleCustomerTransactionAllItemsPdfApiCallSaga(
  action
) {
  try {
    const response = yield call(
      getSingleCustomerTransactionAllItemsPdfApiCall,
      action.payload
    );
    yield put(singleCustomerTransactionAllItemsPDFStatementSuccess(response));
  } catch (error) {
    yield put(singleCustomerTransactionAllItemsPDFStatementError(error));
  }
}

export function* getBankSingleCustomerTransactionAllItemsPdfWatcher() {
  yield takeEvery(
    SINGLE_CUSTOMER_TRANSACTION_ALL_ITEMS_PDF_STATEMENT_REQUEST,
    getBankSingleCustomerTransactionAllItemsPdfApiCallSaga
  );
}

// Bank Account Status List

export function* getBankAccountStatusListApiCallSaga() {
  try {
    const response = yield call(getBankAccountStatusListApiCall);
    yield put(getBankAccountStatusListSuccess(response));
  } catch (error) {
    yield put(getBankAccountStatusListError(error));
  }
}

export function* getBankAccountStatusListWatcher() {
  yield takeEvery(
    GET_BANK_ACCOUNT_STATUS_LIST,
    getBankAccountStatusListApiCallSaga
  );
}

// Bank Transaction Allocation Delete Transaction

export function* getBankTransactionAllocationDeleteTransactionApiCallSaga(
  action
) {
  try {
    const response = yield call(
      getBankTransactionAllocationDeleteTransactionApiCall,
      action.payload
    );
    yield put(bankTransactionAllocationDeleteTransactionSuccess(response));
  } catch (error) {
    yield put(bankTransactionAllocationDeleteTransactionError(error));
  }
}

export function* getBankTransactionAllocationDeleteTransactionWatcher() {
  yield takeEvery(
    BANK_TRANSACTION_ALLOCATION_DELETE_TRANSACTION_REQUEST,
    getBankTransactionAllocationDeleteTransactionApiCallSaga
  );
}

// Get Manual Bank Transaction Details

export function* getManualBankTransactionDetailsApiCallSaga(action) {
  try {
    const response = yield call(
      getManualBankTransactionDetailsApiCall,
      action.payload
    );
    yield put(getManualBankTransactionDetailsSuccess(response));
  } catch (error) {
    yield put(getManualBankTransactionDetailsError(error));
  }
}

export function* getManualBankTransactionDetailsWatcher() {
  yield takeEvery(
    GET_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST,
    getManualBankTransactionDetailsApiCallSaga
  );
}

// Update Manual Bank Transaction Details

export function* getUpdateManualBankTransactionDetailsApiCallSaga(action) {
  try {
    const response = yield call(
      getUpdateManualBankTransactionDetailsApiCall,
      action.payload
    );
    yield put(updateManualBankTransactionDetailsSuccess(response));
  } catch (error) {
    yield put(updateManualBankTransactionDetailsError(error));
  }
}

export function* getUpdateManualBankTransactionDetailsWatcher() {
  yield takeEvery(
    UPDATE_MANUAL_BANK_TRANSACTION_DETAILS_REQUEST,
    getUpdateManualBankTransactionDetailsApiCallSaga
  );
}

// Bank Account Provider List

export function* getBankAccountProviderListApiCallSaga() {
  try {
    const response = yield call(getBankAccountProviderListApiCall);
    yield put(bankAccountProviderListSuccess(response));
  } catch (error) {
    yield put(bankAccountProviderListError(error));
  }
}

export function* getBankAccountProviderListWatcher() {
  yield takeEvery(
    BANK_ACCOUNT_PROVIDER_LIST_REQUEST,
    getBankAccountProviderListApiCallSaga
  );
}

// Get Bank Account Status Data
export function* getBankAccountStatusDataApiCallSaga(action) {
  try {
    const response = yield call(
      getBankAccountStatusDataApiCall,
      action.payload
    );
    yield put(getBankAccountStatusDataSuccess(response));
  } catch (error) {
    yield put(getBankAccountStatusDataError(error));
  }
}

export function* getBankAccountStatusDataWatcher() {
  yield takeEvery(
    GET_BANK_ACCOUNT_STATUS_DATA_REQUEST,
    getBankAccountStatusDataApiCallSaga
  );
}

// Create Bank Account Status
export function* createBankAccountStatusApiCallSaga(action) {
  try {
    const response = yield call(createBankAccountStatusApiCall, action.payload);
    yield put(createBankAccountStatusSuccess(response));
  } catch (error) {
    yield put(createBankAccountStatusError(error));
  }
}

export function* createBankAccountStatusWatcher() {
  yield takeEvery(
    CREATE_BANK_ACCOUNT_STATUS_REQUEST,
    createBankAccountStatusApiCallSaga
  );
}

// Update Bank Account Status
export function* updateBankAccountStatusApiCallSaga(action) {
  try {
    const response = yield call(updateBankAccountStatusApiCall, action.payload);
    yield put(updateBankAccountStatusSuccess(response));
  } catch (error) {
    yield put(updateBankAccountStatusError(error));
  }
}

export function* updateBankAccountStatusWatcher() {
  yield takeEvery(
    UPDATE_BANK_ACCOUNT_STATUS_REQUEST,
    updateBankAccountStatusApiCallSaga
  );
}

// Delete Bank Account Status
export function* deleteBankAccountStatusApiCallSaga(action) {
  try {
    const response = yield call(deleteBankAccountStatusApiCall, action.payload);
    yield put(deleteBankAccountStatusSuccess(response));
  } catch (error) {
    yield put(deleteBankAccountStatusError(error));
  }
}

export function* deleteBankAccountStatusWatcher() {
  yield takeEvery(
    DELETE_BANK_ACCOUNT_STATUS_REQUEST,
    deleteBankAccountStatusApiCallSaga
  );
}

// Bank Account Feed Connection
export function* getBankAccountFeedConnectionApiCallSaga(action) {
  try {
    const response = yield call(
      getBankAccountFeedConnectionApiCall,
      action.payload
    );
    yield put(bankAccountFeedConnectionSuccess(response));
  } catch (error) {
    yield put(bankAccountFeedConnectionError(error));
  }
}

export function* getBankAccountFeedConnectionWatcher() {
  yield takeEvery(
    BANK_ACCOUNT_FEED_CONNECTION_REQUEST,
    getBankAccountFeedConnectionApiCallSaga
  );
}

// Bank Account Feed Map Accounts

export function* getBankAccountFeedMapAccountsApiCallSaga(action) {
  try {
    const response = yield call(
      getBankAccountFeedMapAccountsApiCall,
      action.payload
    );
    yield put(bankAccountFeedMapAccountsSuccess(response));
  } catch (error) {
    yield put(bankAccountFeedMapAccountsError(error));
  }
}

export function* getBankAccountFeedMapAccountsWatcher() {
  yield takeEvery(
    BANK_ACCOUNT_FEED_MAP_ACCOUNTS_REQUEST,
    getBankAccountFeedMapAccountsApiCallSaga
  );
}

// Bank Transaction Import

export function* getBankTransactionImportApiCallSaga(action) {
  try {
    const response = yield call(
      getBankTransactionImportApiCall,
      action.payload
    );
    yield put(bankTransactionImportSuccess(response));
  } catch (error) {
    yield put(bankTransactionImportError(error));
  }
}

export function* getBankTransactionImportWatcher() {
  yield takeEvery(
    BANK_TRANSACTION_IMPORT_REQUEST,
    getBankTransactionImportApiCallSaga
  );
}

// Bank Transaction Allocation Unclear

export function* getBankTransactionAllocationUnclearApiCallSaga(action) {
  try {
    const response = yield call(
      getBankTransactionAllocationUnclearApiCall,
      action.payload
    );
    yield put(bankTransactionAllocationUnclearSuccess(response));
  } catch (error) {
    yield put(bankTransactionAllocationUnclearError(error));
  }
}

export function* getBankTransactionAllocationUnclearWatcher() {
  yield takeEvery(
    BANK_TRANSACTION_ALLOCATION_UNCLEAR_REQUEST,
    getBankTransactionAllocationUnclearApiCallSaga
  );
}

// Bank Transaction Allocation Split

export function* getBankTransactionAllocationSplitApiCallSaga(action) {
  try {
    const response = yield call(
      getBankTransactionAllocationSplitApiCall,
      action.payload
    );
    yield put(bankTransactionAllocationSplitSuccess(response));
  } catch (error) {
    yield put(bankTransactionAllocationSplitError(error));
  }
}

export function* getBankTransactionAllocationSplitWatcher() {
  yield takeEvery(
    BANK_TRANSACTION_ALLOCATION_SPLIT_REQUEST,
    getBankTransactionAllocationSplitApiCallSaga
  );
}
// Bank Account Feed Reconnection
export function* getBankAccountFeedReconnectionApiCallSaga(action) {
  try {
    const response = yield call(
      getBankAccountFeedReconnectionApiCall,
      action.payload
    );
    yield put(bankAccountFeedReconnectionSuccess(response));
  } catch (error) {
    yield put(bankAccountFeedReconnectionError(error));
  }
}
export function* getBankAccountFeedReconnectionWatcher() {
  yield takeEvery(
    BANK_ACCOUNT_FEED_RECONNECTION_REQUEST,
    getBankAccountFeedReconnectionApiCallSaga
  );
}
// Clearing Document Search
export function* searchClearingDocumentApiCallSaga(action) {
  try {
    const response = yield call(searchClearingDocumentApiCall, action.payload);
    yield put(clearingDocumentSearchSuccess(response));
  } catch (error) {
    yield put(clearingDocumentSearchError(error));
  }
}
export function* clearingDocumentSearchWatcher() {
  yield takeEvery(
    CLEARING_DOCUMENT_SEARCH_REQUEST,
    searchClearingDocumentApiCallSaga
  );
}

// Bank Transaction Allocation Autoclear
export function* getBankTransactionAllocationAutoClearApiCallSaga(action) {
  try {
    const response = yield call(
      getBankTransactionAllocationAutoClearApiCall,
      action.payload
    );
    yield put(bankTransactionAllocationAutoClearSuccess(response));
  } catch (error) {
    yield put(bankTransactionAllocationAutoClearError(error));
  }
}

export function* bankTransactionAllocationAutoClearWatcher() {
  yield takeEvery(
    BANK_TRANSACTION_ALLOCATION_AUTOCLEAR_REQUEST,
    getBankTransactionAllocationAutoClearApiCallSaga
  );
}

// Bank Account Attachment (bank statements) Search
export function* searchBankAccountAttachmentSaga(action) {
  try {
    const response = yield call(
      searchBankAccountAttachmentApiCall,
      action.payload
    );
    yield put(searchBankAccountAttachmentSuccess(response));
  } catch (error) {
    yield put(searchBankAccountAttachmentFailure(error));
  }
}

export function* searchBankAccountAttachmentWatcher() {
  yield takeEvery(BANK_ACCOUNT_ATTACHMENT_SEARCH, searchBankAccountAttachmentSaga);
}

// Bank Account Attachment (bank statements) Delete
export function* deleteBankAccountAttachmentSaga(action) {
  try {
    const response = yield call(
      deleteBankAccountAttachmentApiCall,
      action.payload
    );
    yield put(deleteBankAccountAttachmentSuccess(response));
  } catch (error) {
    yield put(deleteBankAccountAttachmentFailure(error));
  }
}

export function* deleteBankAccountAttachmentWatcher() {
  yield takeEvery(BANK_ACCOUNT_ATTACHMENT_DELETE, deleteBankAccountAttachmentSaga);
}

// Bank Account Statement (bank statements with a period) Search
export function* searchBankAccountStatementSaga(action) {
  try {
    const response = yield call(
      searchBankAccountStatementApiCall,
      action.payload
    );
    yield put(searchBankAccountStatementSuccess(response));
  } catch (error) {
    yield put(searchBankAccountStatementFailure(error));
  }
}

export function* searchBankAccountStatementWatcher() {
  yield takeEvery(BANK_ACCOUNT_STATEMENT_SEARCH, searchBankAccountStatementSaga);
}

// Bank Account Statement (bank statements with a period) Delete
export function* deleteBankAccountStatementSaga(action) {
  try {
    const response = yield call(
      deleteBankAccountStatementApiCall,
      action.payload
    );
    yield put(deleteBankAccountStatementSuccess(response));
  } catch (error) {
    yield put(deleteBankAccountStatementFailure(error));
  }
}

export function* deleteBankAccountStatementWatcher() {
  yield takeEvery(BANK_ACCOUNT_STATEMENT_DELETE, deleteBankAccountStatementSaga);
}

function* Bank() {
  yield all([
    getBankListWatcher(),
    getSingleBankTransactionWatcher(),
    getAllBanksTransactionListWatcher(),
    getBankUnAllocatedTransactionListWatcher(),
    getBankUnAllocatedItemListWatcher(),
    getBankClearTransactionAndItemRecquestWatcher(),
    getBankUnClearTransactionAndItemRecquestWatcher(),
    getCustomerSearchAllTransactionsWatcher(),
    getSupplierSearchAllTransactionsWatcher(),
    getCreateSingleBankTransactionWatcher(),
    getBankSingleCustomerTransactionStatmentPdfWatcher(),
    getBankUploadTransactionsFileWatcher(),
    getAssignedOnlyBankTransactionListWatcher(),
    getBankAssignTransactionToCustomerWatcher(),
    getBankUnassignTransactionFromCustomerWatcher(),
    getCreateBankWatcher(),
    getUpdateBankWatcher(),
    getDeleteBankWatcher(),
    syncBankTransactionsWatcher(),
    getBankSingleCustomerTransactionOpenItemsPdfWatcher(),
    getBankSingleCustomerTransactionAllItemsPdfWatcher(),
    getBankAccountStatusListWatcher(),
    getBankTransactionAllocationDeleteTransactionWatcher(),
    getManualBankTransactionDetailsWatcher(),
    getUpdateManualBankTransactionDetailsWatcher(),
    getBankAccountProviderListWatcher(),
    getBankAccountStatusDataWatcher(),
    createBankAccountStatusWatcher(),
    updateBankAccountStatusWatcher(),
    deleteBankAccountStatusWatcher(),
    getBankAccountFeedConnectionWatcher(),
    getBankAccountFeedMapAccountsWatcher(),
    getBankTransactionImportWatcher(),
    getBankTransactionAllocationUnclearWatcher(),
    getBankTransactionAllocationSplitWatcher(),
    getBankAccountFeedReconnectionWatcher(),
    clearingDocumentSearchWatcher(),
    bankTransactionAllocationAutoClearWatcher(),
    searchBankAccountAttachmentWatcher(),
    deleteBankAccountAttachmentWatcher(),
    searchBankAccountStatementWatcher(),
    deleteBankAccountStatementWatcher(),
  ]);
}

export default Bank;
